import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/homepage/HomePage";
import Personal from "./pages/perssonal/Personal";
import Product from "./Product";
import Company from "./Company";
import TermsOfUse from "./TermsOfUse";
import Pay from "./PaymentLnk/Pay";
import InvoicePay from "./Invoice/Pay";
import "animate.css/animate.compat.css";
import Checkout from "./PaymentLnk/Checkout";
import SuccessPage from "./PaymentLnk/SuccessPage";
import Page404 from "./404";
import Privacy from "./Privacy";
import NewCompany from "./pages/NewCompany";
import BlogList from "./blog";
import BlogDetail from "./pages/blog/blogDetails";
import Business from "./pages/business";

function App() {
  return (
    <Router>
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/personal" element={<Personal />} />
          <Route path="/business" element={<Business />} />
          <Route path="/product" element={<Product />} />
          <Route path="/company" element={<NewCompany />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/pay/:slug" element={<Pay />} />
          <Route path="/pay-invoice/:slug" element={<InvoicePay />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/success" element={<SuccessPage />} />
          {/* <Route path="/newcompany" element={<NewCompany />} /> */}
          <Route path="*" element={<Page404 />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
